<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.98,782.5L0.98,782.5c1.06,0,1.92,0.86,1.92,1.92l0,0c0,0,0,0,0,0c0,0.13-0.01,0.25-0.03,0.36l2.15,2.15l0.76-0.76v-0.96
	h0.96l2.88,2.88v1.92l-2.52-2.52l-2.88,2.88l2.52,2.52H4.82l-2.88-2.88v-0.96H2.9l0.76-0.76l-2.06-2.06l0.01,0
	c-0.2,0.07-0.41,0.11-0.64,0.11h0c-0.28,0-0.54-0.06-0.77-0.16l-3.19,2.73l2.92,4.1c1.69,0.4,2.96,1.92,2.96,3.73
	c0,0.01,0,0.01,0,0.02v2.54l1.92,1.28v1.92H-6.7v-1.92l1.92-1.28v-2.56v0c0-0.13,0.03-0.25,0.04-0.37l-3.27-4.58l0.04,0.05
	c-0.42-0.51-0.65-1.15-0.65-1.82c0-1.58,1.3-2.88,2.88-2.88l0,0c0.35,0,0.66,0.07,0.95,0.17l3.88-3.24l0-0.01
	C-0.73,783.17,0.05,782.5,0.98,782.5L0.98,782.5z M-5.74,789.05c-0.54,0-0.96,0.42-0.96,0.96c0,0.22,0.08,0.43,0.22,0.6l2.62,3.67
	c0.42-0.5,0.95-0.89,1.56-1.13l-2.8-3.93c0.06,0.09-0.02-0.01-0.15-0.07C-5.39,789.1-5.58,789.05-5.74,789.05L-5.74,789.05
	L-5.74,789.05z M-2.86,796.74c0,1.07,0.85,1.92,1.92,1.92c1.07,0,1.92-0.85,1.92-1.92s-0.85-1.92-1.92-1.92
	C-2.01,794.81-2.86,795.66-2.86,796.74z"/>
</svg>

</template>